<template>
  <div class="home">
    <h1>欢迎使用 Vue H5 项目</h1>
    <p>这是一个基于 Vue 2 的移动端 H5 项目模板</p>
    
    <div class="counter">
      <h2>计数器示例</h2>
      <p>当前计数：{{ count }}</p>
      <button @click="handleIncrement">+1</button>
      <button @click="handleDecrement">-1</button>
    </div>

    <div class="navigation">
      <router-link to="/about">跳转到关于页面</router-link>

    </div>
     <div class="navigation">
    
      <router-link to="/full-background">全屏背景图页面</router-link>

    </div>
     <div class="navigation">
    
      <router-link to="/pdf-viewer">PDF预览页面</router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'HomePage',
  computed: {
    ...mapState(['count'])
  },
  methods: {
    ...mapMutations(['increment', 'decrement']),
    handleIncrement() {
      this.increment()
    },
    handleDecrement() {
      this.decrement()
    }
  }
}
</script>

<style scoped>
.home {
  padding: 20px;
  text-align: center;
}

h1 {
  color: #42b983;
  margin-bottom: 10px;
}

p {
  color: #666;
  margin-bottom: 20px;
}

.counter {
  margin: 30px 0;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 8px;
}

button {
  margin: 5px;
  padding: 10px 20px;
  font-size: 16px;
  background: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:active {
  background: #35495e;
}

.navigation {
  margin-top: 20px;
}

a {
  color: #42b983;
  text-decoration: none;
}
</style>
